// import 'core-js/fn/array/includes';
// import 'core-js/fn/promise/finally';
// import 'es6-object-assign/auto';
// import 'intl'; // For Safari 9
// import 'regenerator-runtime/runtime';
// import React from 'react';
// import ReactDOM from 'react-dom';

// import BrowserModalComponent from '../components/browser-modal/browser-modal.jsx';
// import analytics, { initialAnalytics } from '../lib/analytics';
// import { getApiUrl } from '../lib/api-config';
// import AppStateHOC from '../lib/app-state-hoc.jsx';
// import supportedBrowser from '../lib/supported-browser';

// import styles from './index.css';

// initialAnalytics();
// analytics.send({ hitType: 'pageview', page: '/community/web' });

// export const appTarget = document.createElement('div');
// appTarget.className = styles.app;
// document.body.appendChild(appTarget);

// function isTokenValid(token) {
//     try {
//         const [, payload] = token.split('.');
//         const decoded = JSON.parse(atob(payload));
//         const exp = decoded.exp;
//         return exp * 1000 > Date.now();
//     } catch (e) {
//         return false;
//     }
// }


// function checkCookies() {
//     try {
//         const testKey = 'test_cookie_check';
//         console.log('[Debug] Starting cookie check...');

//         // Try to set
//         document.cookie = `${testKey}=1; path=/; max-age=60`;
//         const storedCookies = document.cookie;
//         console.log('[Debug] Read back cookies:', storedCookies);

//         const cookieExists = storedCookies.split('; ').some(row => row.trim().startsWith(`${testKey}=`));
//         console.log('[Debug] Cookie exists check:', cookieExists);

//         // Cleanup
//         document.cookie = `${testKey}=; path=/; max-age=0`;

//         return cookieExists;
//     } catch (e) {
//         console.error('[Debug] Cookie check threw error:', e);
//         return false;
//     }
// }


// function getCookie(name) {
//     const value = `; ${document.cookie}`;
//     const parts = value.split(`; ${name}=`);
//     if (parts.length === 2) {
//         return parts.pop().split(';')
//             .shift();
//     }
//     return null;
// }


// function enableAutoLogoutOnClose() {
//     const unloadHandler = e => {
//         document.cookie = 'token=; path=/; max-age=0';
//         e.preventDefault();
//         e.returnValue = '';
//     };


//     window.autoLogoutHandler = unloadHandler;
//     window.addEventListener('beforeunload', unloadHandler);
// }

// function disableAutoLogoutOnClose() {
//     if (window.autoLogoutHandler) {
//         window.removeEventListener('beforeunload', window.autoLogoutHandler);
//         delete window.autoLogoutHandler;
//     }
// }

// if (!checkCookies()) {
//     console.warn('CRITICAL: Cookies are blocked. Rendering blocking UI.');

//     ReactDOM.render(
//         <div
//             style={{
//                 display: 'flex',
//                 flexDirection: 'column',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 height: '100vh',
//                 textAlign: 'center',
//                 fontFamily: 'Arial, sans-serif'
//             }}
//         >
//             <h1 style={{ color: '#d9534f' }}>Cookies are blocked</h1>
//             <p>Please enable cookies in your browser to use this application.</p>
//             <button
//                 onClick={() => window.location.reload()}
//                 style={{
//                     marginTop: '20px',
//                     padding: '10px 20px',
//                     fontSize: '16px',
//                     backgroundColor: '#0275d8',
//                     color: 'white',
//                     border: 'none',
//                     borderRadius: '5px',
//                     cursor: 'pointer'
//                 }}
//             >
//                 Reload
//             </button>
//         </div>,
//         appTarget
//     );

//     // Force a small timeout to let React render first, though alert blocks immediately often
//     setTimeout(() => {
//         alert('Cookies are blocked in your browser. Please enable cookies to continue.');
//     }, 100);
// } else if (supportedBrowser()) {
//     console.log('Is supported browser:', supportedBrowser());

//     const showSignup = () => {
//         console.log('[Auth] Showing Signup view');
//         import('./Signup.jsx').then(module => {
//             module.default(appTarget, showGUI, showLogin);
//         }).catch(err => {
//             console.error('Failed to load Signup', err);
//             appTarget.innerHTML = `<h1>Error loading Signup</h1><pre>${err.message}</pre>`;
//         });
//     };

//     const showLogin = () => {
//         console.log('[Auth] Showing Login view');
//         import('./login.jsx').then(module => {
//             module.default(appTarget, showGUI, showSignup);
//         }).catch(err => {
//             console.error('Failed to load Login', err);
//             appTarget.innerHTML = `<h1>Error loading Login</h1><pre>${err.message}</pre>`;
//         });
//     };

//     const showGUI = () => {
//         console.log('[Auth] Showing GUI view');
//         import('./render-gui.jsx').then(module => {
//             module.default(appTarget);
//         }).catch(err => {
//             console.error('Failed to load GUI', err);
//             appTarget.innerHTML = `<h1>Error loading GUI</h1><pre>${err.message}</pre>`;
//         });
//     };

//     const loginStatus = getCookie('login'); // could be "signup" or null

//     if (loginStatus === 'signup') {
//         showSignup();
//     } else {
//         // Check if user is logged in by calling profile endpoint with credentials
//         console.log('[Auth] Checking session status...');
//         fetch(getApiUrl('profile'), {
//             method: 'GET',
//             headers: { 'Content-Type': 'application/json' },
//             credentials: 'include'
//         })
//             .then(res => {
//                 if (res.ok) {
//                     showGUI();
//                 } else {
//                     showLogin();
//                 }
//             })
//             .catch(err => {
//                 console.error('Auth check failed', err);
//                 showLogin();
//             });
//     }


// } else {
//     BrowserModalComponent.setAppElement(appTarget);
//     const WrappedBrowserModalComponent = AppStateHOC(BrowserModalComponent, true);
//     const handleBack = () => { };
//     ReactDOM.render(<WrappedBrowserModalComponent onBack={handleBack} />, appTarget);
// }





import 'core-js/fn/array/includes';
import 'core-js/fn/promise/finally';
import 'es6-object-assign/auto';
import 'intl'; // For Safari 9
import 'regenerator-runtime/runtime';

// Safeguard for Web Serial API in unsupported browsers (Safari, Firefox, etc.)
try {
    if (typeof window !== 'undefined' && typeof navigator !== 'undefined' && !navigator.serial) {
        Object.defineProperty(navigator, 'serial', {
            value: {
                addEventListener: (type, handler) => {
                    console.warn(`navigator.serial.addEventListener('${type}') called but Web Serial is not supported.`);
                },
                removeEventListener: () => { },
                getPorts: async () => [],
                requestPort: async () => {
                    throw new Error('Web Serial API is not supported in this browser. Please use a Chromium-based browser like Google Chrome or Microsoft Edge to use hardware features.');
                }
            },
            configurable: true,
            enumerable: true,
            writable: true
        });
    }
} catch (e) {
    console.warn('Failed to inject navigator.serial safeguard:', e);
}


import React from 'react';
import ReactDOM from 'react-dom';

import BrowserModalComponent from '../components/browser-modal/browser-modal.jsx';
import analytics, { initialAnalytics } from '../lib/analytics';
import { getApiUrl, SSO_MODE } from '../lib/api-config';
import { startSsoLogin } from '../lib/sso';
import { platformLaunch } from '../lib/sso-launch';
import { withReauth } from '../lib/sso-reauth';
import AppStateHOC from '../lib/app-state-hoc.jsx';
import supportedBrowser from '../lib/supported-browser';

// import styles from './index.css';

// initialAnalytics();

import styles from './index.css';
import { installStaticApi } from './staticApi';

// Static data mode: answers the Admin / Super Admin API requests from local static data
installStaticApi();
// Petals-linked session refused at its entitlement recheck: sign in through Petals again.
if (SSO_MODE !== 'local' && typeof window !== 'undefined' && typeof window.fetch === 'function') {
    window.fetch = withReauth(window.fetch.bind(window), process.env.API_ORIGIN,
        () => startSsoLogin(`${window.location.pathname}${window.location.search}`));
}

initialAnalytics();

analytics.send({ hitType: 'pageview', page: '/community/web' });

export const appTarget = document.createElement('div');
appTarget.className = styles.app;
document.body.appendChild(appTarget);

function isTokenValid(token) {
    try {
        const [, payload] = token.split('.');
        const decoded = JSON.parse(atob(payload));
        const exp = decoded.exp;
        return exp * 1000 > Date.now();
    } catch (e) {
        return false;
    }
}


function checkCookies() {
    try {
        const testKey = 'test_cookie_check';
        console.log('[Debug] Starting cookie check...');

        // Try to set
        document.cookie = `${testKey}=1; path=/; max-age=60`;
        const storedCookies = document.cookie;
        console.log('[Debug] Read back cookies:', storedCookies);

        const cookieExists = storedCookies.split('; ').some(row => row.trim().startsWith(`${testKey}=`));
        console.log('[Debug] Cookie exists check:', cookieExists);

        // Cleanup
        document.cookie = `${testKey}=; path=/; max-age=0`;

        return cookieExists;
    } catch (e) {
        console.error('[Debug] Cookie check threw error:', e);
        return false;
    }
}


function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
        return parts.pop().split(';')
            .shift();
    }
    return null;
}


function enableAutoLogoutOnClose() {
    const unloadHandler = e => {
        document.cookie = 'token=; path=/; max-age=0';
        e.preventDefault();
        e.returnValue = '';
    };


    window.autoLogoutHandler = unloadHandler;
    window.addEventListener('beforeunload', unloadHandler);
}

function disableAutoLogoutOnClose() {
    if (window.autoLogoutHandler) {
        window.removeEventListener('beforeunload', window.autoLogoutHandler);
        delete window.autoLogoutHandler;
    }
}

if (!checkCookies()) {
    console.warn('CRITICAL: Cookies are blocked. Rendering blocking UI.');

    ReactDOM.render(
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100vh',
                textAlign: 'center',
                fontFamily: 'Arial, sans-serif'
            }}
        >
            <h1 style={{ color: '#d9534f' }}>Cookies are blocked</h1>
            <p>Please enable cookies in your browser to use this application.</p>
            <button
                onClick={() => window.location.reload()}
                style={{
                    marginTop: '20px',
                    padding: '10px 20px',
                    fontSize: '16px',
                    backgroundColor: '#0275d8',
                    color: 'white',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer'
                }}
            >
                Reload
            </button>
        </div>,
        appTarget
    );


} else if (supportedBrowser()) {
    console.log('Is supported browser:', supportedBrowser());

    const showSignup = () => {
        console.log('[Auth] Showing Signup view');
        import('./Signup.jsx').then(module => {
            module.default(appTarget, showGUI, showLogin);
        }).catch(err => {
            console.error('Failed to load Signup', err);
            appTarget.innerHTML = `<h1>Error loading Signup</h1><pre>${err.message}</pre>`;
        });
    };

    const showAdminDashboard = () => {
        console.log('[Auth] Showing Admin dashboard');
        import('./admin/AdminDashboard.jsx').then(module => {
            module.default(appTarget, showLogin);
        }).catch(err => {
            console.error('Failed to load Admin dashboard', err);
            appTarget.innerHTML = `<h1>Error loading Admin dashboard</h1><pre>${err.message}</pre>`;
        });
    };

    const showSuperAdminDashboard = () => {
        console.log('[Auth] Showing Super Admin dashboard');
        import('./superAdmin/SuperAdminDashboard.jsx').then(module => {
            module.default(appTarget, showLogin);
        }).catch(err => {
            console.error('Failed to load Super Admin dashboard', err);
            appTarget.innerHTML = `<h1>Error loading Super Admin dashboard</h1><pre>${err.message}</pre>`;
        });
    };


    const routeByRole = (role) => {
        if (role === 'super_admin') {
            showSuperAdminDashboard();
        } else if (role === 'admin') {
            showAdminDashboard();
        } else {
            showGUI();
        }
    };

    const showLogin = () => {
        const params = new URLSearchParams(window.location.search);
        if (SSO_MODE === 'oidc' && !params.get('sso_error')) {
            startSsoLogin();      // SSO-only mode: no password form
            return;
        }

        console.log('[Auth] Showing Login view');
        import('./login.jsx').then(module => {
            module.default(appTarget, showGUI, showSignup, routeByRole);
        }).catch(err => {
            console.error('Failed to load Login', err);
            appTarget.innerHTML = `<h1>Error loading Login</h1><pre>${err.message}</pre>`;
        });
    };

    const showGUI = () => {
        console.log('[Auth] Showing GUI view');
        import('./render-gui.jsx').then(module => {
            module.default(appTarget);
        }).catch(err => {
            console.error('Failed to load GUI', err);
            appTarget.innerHTML = `<h1>Error loading GUI</h1><pre>${err.message}</pre>`;
        });
    };

    const loginStatus = getCookie('login'); // could be "signup" or null
    const launch = platformLaunch(window.location.search, SSO_MODE);

    if (launch) {
        // Petals Platform tile (/?sso=1): straight to Petals, even over an existing CodeCraft
        // session, so CodeCraft always opens as the Platform user. Silent when Petals has a session.
        startSsoLogin('/', launch.org);
    } else if (loginStatus === 'signup') {
        showSignup();
    } else {
        // Check if user is logged in by calling profile endpoint with credentials
        console.log('[Auth] Checking session status...');
        fetch(getApiUrl('profile'), {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'include'
        })
            .then(res => {
                if (!res.ok) {
                    showLogin();
                    return null;
                }
                return res.json();
            })
            .then(data => {
                if (!data) return;
                routeByRole(data?.data?.user_type);
            })

            .catch(err => {
                console.error('Auth check failed', err);
                showLogin();
            });
    }


} else {
    BrowserModalComponent.setAppElement(appTarget);
    const WrappedBrowserModalComponent = AppStateHOC(BrowserModalComponent, true);
    const handleBack = () => { };
    ReactDOM.render(<WrappedBrowserModalComponent onBack={handleBack} />, appTarget);
}
